<ag-sales-list
  [requestObject]="requestObject"
  [options]="{ refundDate: false }"
>
</ag-sales-list>
